import { type FC, useEffect, useLayoutEffect, useRef } from 'react';
import ActionBar from '@/components/action-bar';
import Flow from '@/components/flow';
import FlowDrawer from '@/components/flow-drawer';
import { NotificationWrapper } from '@/components/notification-wrapper';
import useFlow from '@/hooks/use-flow';
import { useSocketEvents } from '@/hooks/use-socket-events.ts';
import useAppStore from '@/store/app';
import useFlowStore from '@/store/flow';
import type { TAccount } from '@/types/common.ts';

interface IAppProps {
	clientSecret: string;
	account: TAccount;
}

const App: FC<IAppProps> = ({ clientSecret, account }) => {
	const { initApp } = useFlow();
	const resetAppState = useAppStore((state) => state.resetState);
	const resetFlowState = useFlowStore((state) => state.resetState);
	const activeContextRef = useRef<string | null>(null);
	const contextKey =
		clientSecret && account?.id ? `${account.id}:${clientSecret}` : null;

	useLayoutEffect(() => {
		if (!contextKey || activeContextRef.current === contextKey) {
			return;
		}

		resetFlowState();
		resetAppState();
		activeContextRef.current = contextKey;
	}, [contextKey, resetAppState, resetFlowState]);

	useEffect(() => {
		if (clientSecret && account) {
			initApp(clientSecret, account);
		}
	}, [initApp, clientSecret, account]);

	useSocketEvents();

	return (
		<>
			<ActionBar />
			<NotificationWrapper />
			<Flow />
			<FlowDrawer />
		</>
	);
};

export default App;
